module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_large_lv-e028e9fecb762c74b423737245537d97.png";